import IndividualCoach from './IndividualCoach';

export default class IndividualCoachForm {
  constructor(
    id = null,
    days = [],
    user = null,
    trainer = null,
    program = null,
    questionnaire = null,
    notes = null,
    start_date= null,
    time = null,
    status = null,
    created = null
  ) {
    this.id = id;
    this.days = days;
    this.user = user;
    this.trainer = trainer;
    this.program = program;
    this.questionnaire = questionnaire;
    this.notes = notes;
    this.start_date= start_date;
    this.time = time;
    this.status = status;
    this.created = created;
  }

  formatforDB() {
    const data = {
      id: this.id,
      days: this.days,
      user: this.user,
      trainer: this.trainer,
      program: this.program,
      questionnaire: this.questionnaire,
      notes: this.notes,
      start_date: this.start_date,
      time: this.time,
      status: this.status,
      created: this.created,
    }

    return new IndividualCoach(
      data.id,
      data.days,
      data.user,
      data.trainer,
      data.program,
      data.Feedbacks,
      data.programs_history,
      data.questionnaire,
      data.notes,
      data.start_date,
      data.time,
      data.status,
      data.created
    );
  }

  formatForForm(obj) {
    const individualCoach = new IndividualCoach();
    if (obj) {
      for (const key in individualCoach) {
        if (obj.hasOwnProperty(key)) {
          individualCoach[key] = obj[key];
        }
      }
    }

    this.id = individualCoach.id;
    this.days = individualCoach.days;
    this.user = individualCoach.user;
    this.trainer = individualCoach.trainer;
    this.program = individualCoach.program;
    this.Feedbacks = individualCoach.Feedbacks;
    this.programs_history = individualCoach.programs_history;
    this.questionnaire = individualCoach.questionnaire;
    this.notes = individualCoach.notes;
    this.start_date= individualCoach.start_date;
    this.time = individualCoach.time;
    this.status = individualCoach.status;
    this.created = individualCoach.created

    this.checkValidity();
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
